/**
 * 앱 웹뷰 안인지. 웹뷰 버전마다 심어주는 게 달라서(플래그만 넣는 쪽, 브릿지만 넣는 쪽)
 * 셋 중 하나만 있어도 앱으로 인정.
 *
 * portalApiKey 쿼리는 여기 넣지 말 것. 이 함수가 토큰 승격을 허용하는 조건이라,
 * 쿼리를 근거로 삼으면 URL 에 키만 붙이면 스스로 승격을 허가하는 셈이 됨.
 * SSR 에는 window 가 없어 false.
 */
export const isRnHost = (): boolean => {
  if (typeof window === 'undefined') return false;

  return Boolean(
    window.isRNWebview || window.isRNWebview2 || window.ReactNativeWebView,
  );
};

/**
 * 호스트 앱 모드인지. 앱 웹뷰이거나, 외부 호스트가 portalApiKey 로 토큰을 넘겨준 상태.
 *
 * 반드시 isRnHost 를 포함할 것. 토큰 승격이 URL 에서 portalApiKey 를 지우기 때문에,
 * 쿼리만 보면 승격 직후 앱 모드가 풀려 GNB 가 되살아남.
 *
 * 첨부 업로드 상태 모달처럼 호스트가 대신 처리하는 UI 는 앱 모드에서 숨김.
 */
const isInApp = (): boolean => {
  if (typeof window === 'undefined') return false;

  if (isRnHost()) return true;

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('portalApiKey')) return true;
  } catch {
    // window.location 접근 실패 — 앱 모드 아님으로 처리
  }

  return false;
};

export default isInApp;
